import React from 'react';
import {
  Dialog,
  DialogContent,
  Button,
  Grid,
  Divider,
  DialogActions,
  DialogContentText,
  DialogTitle,
  makeStyles,
} from '@material-ui/core';
import PropTypes from 'prop-types';

// Custom Styles
const useStyles = makeStyles((theme) => ({
  headingTitle: {
    backgroundColor: '#dbeef3',
    color: '#000',
    fontSize: '18px',
    fontWeight: '700',
    padding: '15px',
    textAlign: 'center',
  },
  paragraphText: {
    color: '#010101',
    padding: '10px',
  },
}));

const AlertDialog = (props) => {
  const classes = useStyles();
  const { open, opts } = props;
  const { title, description, btnOkText, btnCancelText, onClose } = opts;

  const handleClose = (selectedValue) => {
    onClose(selectedValue);
  };

  return (
    <Dialog
      disableEscapeKeyDown
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      open={open}
      class="IHAlertDialog"
      PaperProps={{
        style: { borderRadius: 20 }
      }}
    >
      <DialogTitle id="alert-dialog-title" className={classes.headingTitle}>{title}</DialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText id="alert-dialog-description" className={classes.paragraphText}>
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{padding: '0 35px 30px'}}>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}
        >
          <Grid item>
            <Button
              onClick={() => handleClose(false)}
              variant="contained"
              color="secondary"
            >
              {btnCancelText}
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={() => handleClose(true)}
              color="primary"
              autoFocus
              variant="contained"
            >
              {btnOkText}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

AlertDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  opts: PropTypes.exact({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    btnOkText: PropTypes.string.isRequired,
    btnCancelText: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
  }),
};

export default AlertDialog;
